/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
// https://codepen.io/nzbin/pen/GGrXbp
import s from "./LoadingDots.module.css";

const LoadingDots = () => {
  return <div className={s.dotFlashing} test-id="2w_IJ465" />;
};

export default LoadingDots;